import { Button } from 'primereact/button';
import React, { useEffect } from 'react';
import { NavigateAction, View } from 'react-big-calendar';
import dateUtils from '../../../../../../utils/date-format';
import dateFormat from '../../../../../../utils/date-format';
import globalConfigStore from '../../../../../../stores/global-config-store';
import globalCourseCalendarStore from '../../../../../../stores/global-course-calendar';
import { toast } from 'react-toastify';

interface CourseLectureEventCalendarTollBarModel {
  label: string; // The label text for the toolbar (e.g., current month or week).
  onNavigate: (action: NavigateAction) => void; // Function to handle navigation (e.g., previous, next, today).
  onView: (view: View) => void; // Function to switch views (e.g., month, week, day).
  view: View; // Current view (e.g., "month", "week", "day").
}
export const CourseLectureEventCalendarTollBar: React.FC<
  CourseLectureEventCalendarTollBarModel
> = ({ label, onNavigate, view, onView }) => {
  const formatter = new Intl.DateTimeFormat('he-IL', {
    month: 'long',
    year: 'numeric',
  });

  let displayLabel;

  try {
    if (view === 'day') {
      displayLabel = dateFormat.displayFormatDate(new Date(label));
    } else if (view === 'week') {
      //displayLabel = dateFormat.displayFormatDate(new Date(label));

      const date = new Date(label);

      // Get the Sunday of the current week
      const startOfWeek = new Date(date);
      startOfWeek.setDate(date.getDate() - date.getDay());

      // Get the Saturday of the current week
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      // Format the dates using dateUtils
      displayLabel = `${dateUtils.displayFormatDate(endOfWeek)} - ${dateUtils.displayFormatDate(startOfWeek)}`;
    } else {
      const singleDate = new Date(label);
      if (isNaN(singleDate.getTime())) {
        throw new Error('Invalid single date');
      }
      displayLabel = formatter.format(singleDate);
    }
  } catch (error) {
    console.error('Error parsing label:', error.message);
    displayLabel = 'תאריך לא חוקי';
  }

  const loadCalendarEvents = async () => {
    const currentDate = new Date(label);

    try {
      await globalCourseCalendarStore.loadCalendarEvents(
        globalConfigStore.rootFilter?.currentBranches?.id,
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
      );
    } catch (e) {
      toast.warn(`טעינת המידע נכשלה, נסה שוב בעוד מספר רגעים`);
    }
  };

  const handleNext = async () => {
    onNavigate('NEXT');
    await loadCalendarEvents();
  };

  const handlePrev = async () => {
    onNavigate('PREV');
    await loadCalendarEvents();
  };

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Button style={{ height: '25px' }} outlined={true} onClick={handlePrev}>
          הקודם
        </Button>
        <span
          style={{
            fontWeight: 'bold',
            marginRight: '8px',
            marginLeft: '8px',
          }}
        >
          {displayLabel}
        </span>
        <Button style={{ height: '25px' }} outlined={true} onClick={handleNext}>
          הבא
        </Button>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '4px',
        }}
      >
        <Button
          style={{ height: '25px' }}
          outlined={true}
          onClick={() => onView('month')}
          severity={'secondary'}
        >
          חודש
        </Button>
        <Button
          style={{ height: '25px' }}
          outlined={true}
          onClick={() => onView('week')}
          severity={'secondary'}
        >
          שבוע
        </Button>
        <Button
          style={{ height: '25px' }}
          outlined={true}
          onClick={() => onView('day')}
          severity={'secondary'}
        >
          יום
        </Button>
      </div>
    </div>
  );
};
